import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AcumaticaLoadingOptions } from './AcumaticaLoadingOptions';

@Component({
  template: `
<h3 *ngIf="message" mat-dialog-title style="text-align:center;">
    <div style='white-space: pre-wrap;'>{{message}}</div>
</h3>
<div mat-dialog-content>
    <mat-spinner style="margin:0 auto;" (mousedown)="onMouseDown($event)" (mouseup)="onMouseUp($event)"></mat-spinner>
</div>`,
})
export class AcumaticaLoadingDialogComponent {
  public message: string | null;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: AcumaticaLoadingOptions,
    private dialogRef: MatDialogRef<AcumaticaLoadingDialogComponent>,
  ) {
    this.message = data?.message || null;
  }

  _longpressTimer: any;
  onMouseDown($event: MouseEvent) {
    this._longpressTimer = setTimeout(() => {
      this.dialogRef.close();
    }, 5000);
  }

  onMouseUp($event: MouseEvent) {
    clearTimeout(this._longpressTimer);
  }
}
